<template>
	<section>
		<div class="container">
			<!-- row -->
			<div class="row">
				<div class="col-md-8 col-sm-8">
					<div class="detail-wrapper">
						<div class="detail-wrapper-body">
							<div class="job-title-bar side-list">
								<ul class="category-list">
									<li><i class="ti-location-pin padd-r-10"></i>{{ $t('job-detail.location') }} <span class="">{{ $i18n.locale === 'zh' ? job.work_location.c_fullname : job.work_location.e_fullname }}</span></li>
									<li><i class="ti-timer padd-r-10"></i>{{ $t('job-detail.open-date') }} <span class="">{{ job.create_at | dateFormat('from', $i18n.locale) }}</span></li>
									<li><i class="ti-money padd-r-10"></i>{{ $t('job-detail.salary-range') }} <span class="">{{ salary }}</span></li>
									<li><i class="ti-menu padd-r-10"></i>{{ $t('job-detail.job-type') }} <span class="">{{ jobType }}</span></li>
								</ul>
							</div>
						</div>
					</div>
					
					<div class="detail-wrapper" v-if="job.highlight">
						<div class="detail-wrapper-header">
							<h4>{{ $t('job-detail.summary') }}</h4>
						</div>
						<div class="detail-wrapper-body" v-html="summary">
						</div>
					</div>
					
					<div class="detail-wrapper" v-if="job.responsibility">
						<div class="detail-wrapper-header">
							<h4>{{ $t('job-detail.responsibility') }}</h4>
						</div>
						<div class="detail-wrapper-body" v-html="responsibility">
						</div>
					</div>
					
					<div class="detail-wrapper" v-if="job.requirements">
						<div class="detail-wrapper-header">
							<h4>{{ $t('job-detail.requirement') }}</h4>
						</div>
						<div class="detail-wrapper-body" v-html="requirement">
						</div>
					</div>
					
				</div>
				
				<div class="col-md-4 col-sm-4">
					<div class="sidebar">
					
						<!-- Start: Opening hour -->
						<div class="widget-boxed">
							<div class="widget-boxed-body">
								<a href="javascript:void(0)"  data-toggle="modal" data-target="#apply-job" class="btn btn-m theme-btn full-width mrg-bot-10"><i class="fa fa-paper-plane"></i>{{ $t('job-detail.apply') }}</a>
								<a class="btn btn-m light-gray-btn full-width" @click="showShare = !showShare"><i class="fa fa-share-alt"></i>{{ $t('job-detail.share') }}</a>
								<div v-if="showShare" style="margin-top:20px">
									<Share :config="config" />
								</div>
							</div>
						</div>
						<!-- End: Opening hour -->
						
						<!-- Start: Job Overview -->
						<div class="widget-boxed">
							<div class="widget-boxed-header">
								<h4><i class="fa fa-info-circle padd-r-10"></i>{{ $t('job-detail.info') }}</h4>
							</div>
							<div class="widget-boxed-body">
								<div class="side-list no-border">
									<h5>{{ $t('job-detail.function') }}</h5>
									<p>{{ $i18n.locale === 'zh' ? job.job_function.c_fullname : job.job_function.e_fullname }}</p>
									<!--<h5>{{ $t('job-detail.industry') }}</h5>
									<p>互联网</p>-->
									<h5>{{ $t('job-detail.work-length') }}</h5>
									<p>{{ workExp }}</p>
									<!--<h5>{{ $t('job-detail.consultant') }}</h5>
									<p>Allie Zhao</p>
									<h5>{{ $t('job-detail.tel') }}</h5>
									<p>+86 21 6288 1863</p>-->
									<h5>{{ $t('job-detail.code') }}</h5>
									<p>{{ job.id }}</p>
									
								</div>
							</div>
						</div>
						<!-- End: Job Overview -->
						
						<!-- Start: Contact Consultant -->
						<MessageForm />
						<!-- End: Contact Consultant -->
					</div>
				</div>
			</div>
			<!-- End Row -->
			
			<!-- row -->
			<div class="row">
				<div class="col-md-12">
					<h4 class="mrg-bot-20">{{ $t('job-detail.more') }}</h4>
				</div>
			</div>
			<!-- End Row -->
			
			<!-- row -->
			<div class="row">
				<div class="col-md-3 col-sm-6" v-for="j in jobs" v-if="j.data.id != job.id">
					<JobBox :job="j" />
				</div>
			</div>
			<!-- End Row -->
			
		</div>
	</section>
</template>
<script>
import JobBox from '@/components/JobBox.vue'
import MessageForm from '@/components/detail/MessageForm.vue'
import Share from 'vue-social-share'

export default {
  name: 'JobDetail',
  props: ['job', 'jobs'],
  components: {
    JobBox,
    MessageForm,
    Share
  },
  data: () => ({
	showShare: false
  }),
  computed: {
    config: function() {
      return {
        title: this.job.title.name,
        description: this.job.company_desc,
        wechatQrcodeTitle: this.$t('job-detail.wechat'),
        wechatQrcodeHelper: ''
      }
    },
    salary: function() {
      return this.salaryLabel(this.job.salary_from, this.job.salary_to, this.job.salary_negotiable)
    },
    summary: function() {
      return this.itemize(this.job.highlight)
    },
    responsibility: function() {
      return this.itemize(this.job.responsibility)
    },
    requirement: function() {
      return this.itemize(this.job.requirements)
    },
    jobType: function() {
      return this.jobTypeLabel(this.job.job_type)
    },
    workExp: function() {
      return this.expLabel(this.job.required_experience)
    }
  }
}
</script>